import { ThemeEvents } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

/**
 * <tenc-availability> — section-local availability indicator for the
 * Ten C product template. The Liquid template renders the literal copy
 * ("In stock" / "Last one" / "Sold out"); on variant:update we morph
 * our children from the freshly rendered section HTML, which already
 * contains the correct text for the selected variant.
 */
class TencAvailability extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateAvailability);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateAvailability);
  }

  updateAvailability = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (
      event.target instanceof HTMLElement &&
      event.target.dataset.productId !== this.dataset.productId
    ) {
      return;
    }

    const fresh = event.detail.data.html.querySelector('tenc-availability');
    if (!fresh) return;

    // Sync root attributes (data-state in particular) — morph childrenOnly
    // does not touch the host element, so CSS attribute selectors against
    // the root would otherwise stay stale after variant change.
    for (const attr of fresh.attributes) {
      if (this.getAttribute(attr.name) !== attr.value) {
        this.setAttribute(attr.name, attr.value);
      }
    }
    for (const attr of [...this.attributes]) {
      if (!fresh.hasAttribute(attr.name)) {
        this.removeAttribute(attr.name);
      }
    }

    morph(this, fresh, { childrenOnly: true });
  };
}

if (!customElements.get('tenc-availability')) {
  customElements.define('tenc-availability', TencAvailability);
}
